import { component } from 'picoapp';
import { scrollLock } from 'utils/node';
import Drawer from 'utils/drawer';
import Accordion from 'utils/accordion';

export default component((node) => {
  const navTrigger = document.querySelector('[data-trigger="navigation"]');

  if (node.hasAttribute('data-drawer')) {
    const navDrawer = Drawer(node, node.parentElement);

    if (navTrigger) {
      navTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        navDrawer.toggle();
      });
    }

    navDrawer.on('opened', () => scrollLock());
    navDrawer.on('close', () => scrollLock(false));
  }

  Accordion(node, {
    items: '[data-accordion]',
    trigger: '[data-accordion-trigger]',
    content: '[data-accordion-content]',
  });
});
